import React from "react";
import { AngleLeft, AngleRight } from "../../../IconTheme";

const Pagination = () => {
	return (
		<ul className="__pagination mt-4 mt-md-5">
			<li>
				<button>
					<AngleLeft />
				</button>
			</li>
			<li>
				<button className="active">
					<span>01</span>
				</button>
			</li>
			<li>
				<button>
					<span>02</span>
				</button>
			</li>
			<li>
				<button>
					<span>03</span>
				</button>
			</li>
			<li>...</li>
			<li>
				<button>
					<span>48</span>
				</button>
			</li>
			<li>
				<button>
					<AngleRight />
				</button>
			</li>
		</ul>
	);
};

export default Pagination;
